export default "__VITE_ASSET__CJ7r6oT2__"